module.exports = __webpack_public_path__ + "static/media/CTLI_15-178w.643d8bac.jpg";